import { styled } from 'styles';

export const StyledEllipsis = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

StyledEllipsis.displayName = 'Ellipsis';
